import { render, staticRenderFns } from "./Passageway.vue?vue&type=template&id=47196007&scoped=true&lang=html"
import script from "./Passageway.vue?vue&type=script&lang=js"
export * from "./Passageway.vue?vue&type=script&lang=js"
import style0 from "./Passageway.vue?vue&type=style&index=0&id=47196007&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47196007",
  null
  
)

export default component.exports